import moment from 'moment-timezone';

const readDate = (date, timeZone) => {

	if (!timeZone) {
		timeZone = 'US/Central';
	}

    return moment(date).tz(timeZone).format("YYYY-MM-DD HH:mm:ss");
}

export { readDate };
